import Vue from 'vue';
import Vuex from 'vuex';
import DogModel from '@/models/DogModel';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    test: 'hej',
    dogs: [
      new DogModel(
        1,
        '/images/dogs/Joodii/19759-2004-Foxon-Joodii hoved.jpg-for-web-normal.jpg',
        'Foxon Joodii',
        'Gamefinder Amigo - Foxon Vivivi',
        '19759/2004',
        '12.09.2004',
        'Sort',
        'Komplet',
        'A',
        '0',
        '09.05.2012 - PPM ikke arveligt.',
        'Clear',
        'Clear',
        'Clear',
        'Clear',
        '',
        '/linkTilStamtavle/', // ?
        [
          'Brugsprøve bestået',
          'Unghundemesterskab gennemført 70 point',
          '1 x 1. pr. Markrøve C begynderklasse. Dagens bedste hund af 33 deltagende hunde. Blot 10 måneder gammel',
          '3 x 1. pr. Markprøve B begynderklasse 1 x Dagens bedste hund. (3 x 1. pr i træk)',
          '3 x 1. pr. Markprøve B Åbenkl, 2 x Dagens bedste hund. (3 x 1. pr i træk)',
          '3 x 1. pr. Markprøve A Åben kl, (Praktisk jagt), (3 x 1. pr i træk)',
        ],
        [
          '1. pr. 2 vinder. Unghundeklasse (uofficiel), region Sydsjælland',
          '1. pr. 4 vinder Åben klasse (officiel)',
        ],
        `<p>Foxon Joodii er en mellemstor hanhund af ren jagt/markprøveafstamning, og selv om dette har han et rigtigt godt exteriør. Han har kraftige benstammer og runde poter, og har en god og kraftig pels, tyk odderhale, brædt hoved og mørkebrune øjne. Foxon Joodii er en enormt kærlig hund med et roligt mildt gemyt.</p>
        <p>Han er meget kontaktsøgende og vil SÅ gerne behage sin fører.</p>
        <br />
        <p>Foxon Joodii er altid klar til en gang træning. Han er en letført hund, som arbejder ærligt og trofast med god fart i al slags terræn, og bliver aldrig stresset, en egenskab som bl.a., er værdsat på opsamlinger på større godsjagter hvor der på en kort stund skydes meget vildt. Foxon Joodii har været ukompliceret og legende let at træne, og kvalificerede sig i nærmest overbevisende stil til vinderklasse A og B.</p>
        <br />
        <p>Foxon Joodii er far til flere vildtsporchampions, samt adskillige tjenestelige narkohunde.</p>`,
        []
      ),
      new DogModel(
        2,
        '/images/dogs/Kalle/Kalle - hoved.jpg',
        'Hillsbrook Kalle',
        'Foxon Joodii - Woodmagic Willow',
        'DK01065/2012',
        '31.12.2011',
        'Sort',
        'Komplet',
        'A-A',
        '0-0',
        '',
        'Clear via forældre',
        'Clear via forældre',
        'Clear via forældre',
        '',
        '',
        '/linkTilStamtavle/', // ?
        ['Brugsprøve bestået'],
        [],
        `<p>Kalle er en sød og dejlig hund med et godt hoved.</p>
        <p>Han har fra starten apporteret som om han aldrig har lavet andet. Til hånd fra både land og vand.</p>`,
        []
      ),
      new DogModel(
        3,
        '/images/dogs/Kira/Kira - hoved.jpg',
        'Hillsbrook Kira',
        'Foxon Joodii - Woodmagic Willow',
        'DK01066/2012',
        '31.12.2011',
        'Gul',
        'Komplet',
        'A-A',
        '0-0',
        '',
        'Clear via forældre',
        'Clear via forældre',
        'Clear via forældre',
        '',
        '',
        '/linkTilStamtavle/', // ?
        ['Brugsprøve bestået'],
        [],
        `<p>Kira er en sød og kærlig hund, som har fundet stor glæde i at apportere.</p>
        <p>Hun apportere til hånd, og både på land og i vand.</p>`,
        []
      ),
    ],
  },
  mutations: {},
  actions: {},
  modules: {},
});
